"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useJinnGames = void 0;
var react_1 = require("react");
var keys_1 = require("../keys");
var useQuery_1 = require("../useQuery");
var useJinnGames = function (_a) {
    var gameId = _a.gameId;
    var _b = (0, useQuery_1.useQuery)({
        path: keys_1.JINN_GAMES,
        payload: {
            filter: {
                gameId: gameId,
            },
        },
    }), data = _b.data, error = _b.error, isLoading = _b.isLoading;
    return (0, react_1.useMemo)(function () { return ({
        data: (data === null || data === void 0 ? void 0 : data.data) || [],
        isLoading: isLoading,
        error: error,
    }); }, [data, isLoading, error]);
};
exports.useJinnGames = useJinnGames;
